import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CookiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-gray-50" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>

            <div className="prose prose-gray max-w-none">
              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">1. What Are Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cookies are small text files that are stored on your device when you visit our website. 
                  They help us provide you with a better experience by remembering your preferences and 
                  understanding how you use our site.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
                
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-800 mb-2">Essential Cookies</h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Required for the website to function properly. These cannot be disabled.
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1">
                    <li>Session management</li>
                    <li>Security features</li>
                    <li>Form submission handling</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-800 mb-2">Analytics Cookies</h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Help us understand how visitors interact with our website.
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1">
                    <li>Page views and navigation paths</li>
                    <li>Time spent on pages</li>
                    <li>Error tracking</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-800 mb-2">Functional Cookies</h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Enable enhanced functionality and personalization.
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1">
                    <li>Language preferences</li>
                    <li>Region settings</li>
                    <li>User interface customization</li>
                  </ul>
                </div>

                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-800 mb-2">Marketing Cookies</h3>
                  <p className="text-gray-600 leading-relaxed mb-2">
                    Used to deliver relevant advertisements and track campaign effectiveness.
                  </p>
                  <ul className="list-disc pl-6 text-gray-600 space-y-1">
                    <li>Ad targeting</li>
                    <li>Conversion tracking</li>
                    <li>Retargeting</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Cookie Duration</h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full border border-gray-200 rounded-lg">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Cookie Type</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Duration</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      <tr>
                        <td className="px-4 py-3 text-sm text-gray-600">Session Cookies</td>
                        <td className="px-4 py-3 text-sm text-gray-600">Deleted when browser closes</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3 text-sm text-gray-600">Persistent Cookies</td>
                        <td className="px-4 py-3 text-sm text-gray-600">Up to 2 years</td>
                      </tr>
                      <tr>
                        <td className="px-4 py-3 text-sm text-gray-600">Analytics Cookies</td>
                        <td className="px-4 py-3 text-sm text-gray-600">Up to 26 months</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Managing Cookies</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  You can control and manage cookies through your browser settings. Please note that 
                  disabling certain cookies may affect the functionality of our website.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Most browsers allow you to:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-2">
                  <li>View cookies stored on your device</li>
                  <li>Delete individual or all cookies</li>
                  <li>Block third-party cookies</li>
                  <li>Block cookies from specific sites</li>
                  <li>Accept or reject all cookies</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Contact Us</h2>
                <p className="text-gray-600 leading-relaxed">
                  If you have questions about our use of cookies, please contact us at{' '}
                  <a href="mailto:info@airdelayclaim.com" className="text-blue-600 hover:underline">
                    info@airdelayclaim.com
                  </a>
                </p>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <Link 
                to="/" 
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPage;
